import type { Middleware } from "openapi-fetch";

import { readCookie } from "./readCookie";

// Имена — как в Django по умолчанию (`CSRF_COOKIE_NAME`, `CSRF_HEADER_NAME`).
export const CSRF_COOKIE = "csrftoken";
export const CSRF_HEADER = "X-CSRFToken";

// Методы, которые Django не проверяет на CSRF (RFC 9110, «безопасные»).
const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS", "TRACE"]);

// Вход — сессионная cookie Django, поэтому изменяющие запросы несут токен из cookie `csrftoken`.
export const csrfMiddleware: Middleware = {
  onRequest({ request }) {
    if (SAFE_METHODS.has(request.method)) {
      return undefined;
    }
    const token = readCookie(CSRF_COOKIE);
    if (token !== null) {
      request.headers.set(CSRF_HEADER, token);
    }
    return request;
  },
};
